import { num } from '../utils/num';

/**
 * Classifies a day's logged macros against targets as 'met' | 'partial' |
 * 'missed' | null (no data / nothing evaluable).
 *
 * Only macros with a real, positive target are evaluated. A missing/zero
 * target used to count as an automatic 100% pass, which could show a day
 * as "Goals Met" for a macro that was never actually evaluated (see
 * AGENTS.md pre-launch audit, finding PROG-4).
 */
export function getDayStatus(dayData, targets) {
  if (!dayData || !targets) return null;
  var dCal = num(dayData.calories), dPro = num(dayData.protein), dCarb = num(dayData.carbs), dFat = num(dayData.fat);
  var tCal = num(targets.calories), tPro = num(targets.protein), tCarb = num(targets.carbs), tFat = num(targets.fat);
  if (dCal === 0 && dPro === 0) return null; // No data logged

  var evaluable = 0;
  var onTargetCount = 0;
  if (tCal > 0) {
    evaluable++;
    var calPct = (dCal / tCal) * 100;
    if (calPct >= 85 && calPct <= 115) onTargetCount++;
  }
  if (tPro > 0) {
    evaluable++;
    var proteinPct = (dPro / tPro) * 100;
    if (proteinPct >= 85 && proteinPct <= 115) onTargetCount++;
  }
  if (tCarb > 0) {
    evaluable++;
    var carbsPct = (dCarb / tCarb) * 100; // More lenient range for carbs
    if (carbsPct >= 70 && carbsPct <= 130) onTargetCount++;
  }
  if (tFat > 0) {
    evaluable++;
    var fatPct = (dFat / tFat) * 100; // More lenient range for fat
    if (fatPct >= 70 && fatPct <= 130) onTargetCount++;
  }

  if (evaluable === 0) return null; // no real targets to evaluate against

  // Green: every macro that HAS a real target is on target.
  if (onTargetCount === evaluable) return 'met';

  // Yellow: at least 2 (or all, if fewer than 2 are evaluable) on target.
  if (onTargetCount >= Math.min(2, evaluable)) return 'partial';

  // Red: everything else.
  return 'missed';
}
